<template>
<div>
<h2>Predelovalec</h2>
<h4>{{ predelovalec.naziv }}</h4>
<p>
{{predelovalec.naslov}}, {{predelovalec.postnastevilka}} {{predelovalec.posta}}<br/> 
</p>
</div>
</template>
<script>



export default {
    props: {
      predelovalec:Object   },
    
  
  
  created(){
  	console.log(this.predelovalec);
  }
}
</script>